import { Box } from "@mui/material";

interface ICounterBadgeProps {
  count: number;
  bgcolor?: string | any;
  color?: string | any;
}

export default function CounterBadge({
  count,
  bgcolor,
  color,
}: Readonly<ICounterBadgeProps>) {
  return (
    <Box
      sx={{
        borderRadius: "50%",
        width: "18px",
        height: "18px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "4px",
        fontSize: "9.99px",
        fontWeight: "600",
        bgcolor: bgcolor ? bgcolor : (theme) => theme.palette.dark[40],
        color: color ? color : (theme) => theme.palette.gray.bg,
      }}
    >
      {count}
    </Box>
  );
}
